import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
	stepThree(filter: $filter) {
		insulations {
			id
			name
            mn_label
        }
        socket_locations {
			id
			name
			socket {
				id
				name
                mn_label
                driver_option_id
			}
		}
        surge_protection {
			id
			name
		}
		dimming {
			id
			name
            mn_label
            mn_label_socket_y
            mn_label_socket_z
            driver_option_id
		}
        model_name_pattern {
			id
			title
            order_no
            mn_label_placeholder
            space
            object_id
		}
	}
}`;